import { render, staticRenderFns } from "./PedidosListItem.vue?vue&type=template&id=8075641e&scoped=true&"
import script from "./PedidosListItem.vue?vue&type=script&lang=ts&"
export * from "./PedidosListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PedidosListItem.vue?vue&type=style&index=0&id=8075641e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8075641e",
  null
  
)

export default component.exports